import { render } from "./EventDetailQuestionPage.vue?vue&type=template&id=74f79e45&scoped=true"
import script from "./EventDetailQuestionPage.vue?vue&type=script&lang=js"
export * from "./EventDetailQuestionPage.vue?vue&type=script&lang=js"

import "./EventDetailQuestionPage.vue?vue&type=style&index=0&id=74f79e45&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f79e45"]])

export default __exports__